import { __assign } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { useOption } from 'react-aria';
import { CheckIcon } from '../../../icons/CheckIcon.js';
import { Item as Item$1 } from '../../../base/listBox/item/Item.js';
import { ItemContent } from './itemContent/ItemContent.js';
import styles from './Item.module.scss.js';

var Item = function (_a) {
    var item = _a.item, state = _a.state;
    var ref = useRef(null);
    var isSelected = useOption({
        key: item.key,
    }, state, ref).isSelected;
    return (jsx(Item$1, __assign({ item: item, state: state, className: styles.item, ref: ref, hideCheckIcon: true }, { children: jsx(ItemContent, __assign({ rightIcon: isSelected ? jsx(CheckIcon, {}) : undefined }, { children: item.rendered })) })));
};

export { Item };
